import VideoButton from './VideoButton';

export default VideoButton;
